export default __webpack_public_path__ + "static/media/IMG-20250105-WA0012.db5ed5ea.jpg";